import React, { useState } from "react";
import "./ResultsAnswers.css";

import FilterBlock from "./FilterBlock";
import UpButtonResults from "../../../shared/components/UpBtn/UpButtonResults";
import   "../../../shared/components/UpBtn/UpButtonResults.css";

const ResultsAnswers = (props) => {
  props.finalResultArray.sort(function (a, b) {
    if (parseInt(a.id) < parseInt(b.id)) return -1;
    if (parseInt(a.id) > parseInt(b.id)) return 1;
    return 0;
  });

  const [mergedArray] = useState(
    mergeArrayObjects(props.currentTicket.tasks, props.finalResultArray)
  );
  const [arrToShow, setArrToShow] = useState(mergedArray);
  const [isActiveBtn, setIsactiveBtn] = useState("all");

  const classHandler = (answerIndex, task, taskIndex) => {
    if (answerIndex === task.rightAnswer) return "green ";
    if (task.isError) {
      if (answerIndex === task.clickedAnswer) return "red ";
    }
  };
/* console.log(arrToShow) */
     /* console.log(props.currentTicket, "props.currentTicket");
  console.log(props.finalResultArray, "finalResultArray"); */

  function mergeArrayObjects(arr1, arr2) {
    if (
      props.categoryTickets === "errorsAB" ||
      props.categoryTickets === "errorsCD"
    ) {
      return arr1.map((item, idx) => {
        if (parseInt(item.taskId) === parseInt(arr2[idx].id)) {
          //merging two objects
          return Object.assign({}, item, arr2[idx]);
        } else return 0;
      });
    } else {
      return arr1.map((item, idx) => {
        if (idx + 1 === parseInt(arr2[idx].id)) {
          //merging two objects
          return Object.assign({}, item, arr2[idx]);
        } else return 0;
      });
    }
  }

  /*   console.log(arrToShow, "arrToShow"); */

  const [fadein, setFadein] = useState(0);

  const renderComponent = () => {
    if (arrToShow.length === 0 && isActiveBtn === "right")
      return (
        <div style={{ marginBottom: "3rem" }}>
          <FilterBlock
            mergedArray={mergedArray}
            setArrToShow={setArrToShow}
            setFadein={setFadein}
            isActiveBtn={isActiveBtn}
            setIsactiveBtn={setIsactiveBtn}
          />
          <div
            className="content-block result-answers-block"
            onAnimationEnd={() => setFadein(0)}
            fadein={fadein}
          >
            <p className="center-text">Нет верных ответов</p>
          </div>
        </div>
      );
    else if (arrToShow.length === 0 && isActiveBtn === "err")
      return (
        <div style={{ marginBottom: "3rem" }}>
          <FilterBlock
            mergedArray={mergedArray}
            setArrToShow={setArrToShow}
            setFadein={setFadein}
            isActiveBtn={isActiveBtn}
            setIsactiveBtn={setIsactiveBtn}
          />
          <div
            className="content-block result-answers-block"
            onAnimationEnd={() => setFadein(0)}
            fadein={fadein}
          >
            <p className="center-text"> Вы не совершали ошибок</p>
          </div>
        </div>
      );
    else
      return (
        <div className="result-answers-main">
          <FilterBlock
            mergedArray={mergedArray}
            setArrToShow={setArrToShow}
            setFadein={setFadein}
            isActiveBtn={isActiveBtn}
            setIsactiveBtn={setIsactiveBtn}
          />
          {arrToShow.map((task, taskIndex) => (
            <div
              key={task.id}
              className="content-block result-answers-block"
              onAnimationEnd={() => setFadein(0)}
              fadein={fadein}
            >
              <div style={{ margin: "1rem 0.5rem 3rem 0.5rem" }}>
                <h3 className="result-answers-header">Вопрос {task.id}</h3>
                <div className={task.img === null ? "display-none" : ""}>
                  <img
                    className="task-img"
                    src={task.img}
                    alt="Картинка к вопросу"
                  ></img>
                </div>
                <h2 className="question">{task && task.question}</h2>
                {task && task.answers.map((answer, index) => (
                  <div
                    key={index}
                    className={
                      "answer non-pointer " +
                      classHandler(index, task, taskIndex)
                    }
                    id="answerTest"
                  >
                    <p className="select-answer">
                      <b>{answer.slice(0, 2)}</b>
                      {answer.slice(2, answer.length)}
                      {task.clickedAnswer === index && (
                        <b className="result-answers-your-answer"> Ваш ответ</b>
                      )}
                    </p>
                  </div>
                ))}
                <div className="result-answers-hint">
                  <h5 className="result-answers-hint-header">
                    Комментарий к вопросу
                  </h5>
                  <p className="result-answers-hint-text">{task.hint}</p>
                </div>
              </div>
            </div>
          ))}
          <UpButtonResults/>
        </div>
      );
  };

  return renderComponent();
};

export default ResultsAnswers;
